import { render } from "./logdispemail.vue?vue&type=template&id=4e2c3a05"
import script from "./logdispemail.vue?vue&type=script&lang=js"
export * from "./logdispemail.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\iuril\\Documents\\econopro\\mainapp\\mtex_mobagile_m3_front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__